// session-url.ts — session-id resolution from the URL, shared by BOTH entries
// (the vanilla listener app in main.ts and the React call console in call.tsx).
//
// Priority order:
//   1. ?s=<sessionId> / ?session=<sessionId>   (query param)
//   2. /s/<sessionId> or /session/<sessionId>  (path segment)
//   3. #<sessionId>                            (hash, e.g. /#abc123)

export function resolveSessionId(): string | null {
  const url = new URL(window.location.href);

  const q = url.searchParams.get("s") ?? url.searchParams.get("session");
  if (q) return q.trim();

  // /s/<id> or /session/<id>
  const m = url.pathname.match(/\/(?:s|session)\/([^/?#]+)/);
  if (m && m[1]) return decodeURIComponent(m[1]);

  const hash = url.hash.replace(/^#\/?/, "").trim();
  if (hash) return hash;

  return null;
}
